import React from "react";
import { useLang } from "../context/LanguageContext";
import { PageHeader } from "../components/common/PageHeader";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { FileBarChart, FileSpreadsheet, FileText, Download, Clock } from "lucide-react";

const reportTypes = [
  { id: "disbursement", title: "Disbursement Report", desc: "Loans disbursed across CLFs over a selected period.", icon: FileBarChart },
  { id: "collection", title: "Collection Report", desc: "EMI collections, recovery rate and mode-wise summary.", icon: FileSpreadsheet },
  { id: "overdue", title: "Overdue / NPA Report", desc: "Loans overdue beyond 30, 60, 90 days.", icon: Clock },
  { id: "shg-grading", title: "SHG Grading Report", desc: "Current grade (A+/A/B/C) across all SHGs.", icon: FileText },
  { id: "member-savings", title: "Member Savings Report", desc: "Savings and contributions per member/SHG.", icon: FileText },
  { id: "vo-performance", title: "VO Performance", desc: "Comparative performance of Village Organizations.", icon: FileBarChart },
];

const ReportsPage = () => {
  const { t } = useLang();

  const handleGenerate = (title) => {
    toast.info(`${title} — ${t.common.comingSoon}`, {
      description: "Live report generation will be available in Phase 2.",
    });
  };

  return (
    <div className="mx-auto max-w-7xl">
      <PageHeader title={t.reports.title} subtitle={t.reports.sub} testId="reports-page-header" showSampleBadge={false} />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {reportTypes.map((r) => (
          <div
            key={r.id}
            data-testid={`report-card-${r.id}`}
            className="group flex flex-col rounded-2xl border border-emerald-950/10 bg-white p-5 transition-all hover:border-emerald-700/30 hover:shadow-md"
          >
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-900/8 text-emerald-800">
                <r.icon className="h-5 w-5" />
              </div>
              <h3 className="font-display text-base font-semibold text-emerald-950">{r.title}</h3>
            </div>
            <p className="mt-3 flex-1 text-sm text-emerald-900/60">{r.desc}</p>
            <div className="mt-4 flex items-center justify-between">
              <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-800">
                Preview only
              </span>
              <Button
                variant="outline"
                size="sm"
                data-testid={`report-generate-${r.id}`}
                onClick={() => handleGenerate(r.title)}
                className="border-emerald-900/20 text-emerald-900 hover:bg-emerald-900/5"
              >
                <Download className="mr-1.5 h-3.5 w-3.5" />
                Generate
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportsPage;
